require('./regularExpression.i18n.json');
require('./regularExpressionTemplate.tpl.html');

/*@ngInject*/
const RegularExpressionController = function ($rootScope, $scope, $state, $stateParams, $timeout, localization, coreConstant, configurationConstant, configurationActionsUtil, formViewerConstant, configurationMediator, fieldTemplate, propertyName, propertyValue) {

    var timeoutList = [],
        translations;

    $scope.expressionViewModel = {
        title: '',
        okButton: '',
        cancelButton: '',
        saveButton: '',
        regexpPlaceholder: '',
        testDataPlaceholder: '',
        value: propertyValue,
        testData: '',
        isChanged: false,
        hasError: false
    };

    $scope.uiFormTemplate = null;
    $scope.fieldTemplate = fieldTemplate;

    function init() {
        localization.getTranslationsByKeys(['regularExpression']).then(function (result) {
            translations = result;
            $scope.expressionViewModel.title = translations.title + $scope.fieldTemplate.variableName;
            $scope.expressionViewModel.okButton = translations['confirmButtonLabel'];
            $scope.expressionViewModel.cancelButton = translations['cancelButtonLabel'];
            $scope.expressionViewModel.regexpPlaceholder = translations['regexpPlaceholder'];
            $scope.expressionViewModel.testDataPlaceholder = translations['testDataPlaceholder'];
        });

        configurationMediator.getFormTemplateById($stateParams.uiFormTemplateId).then(function (uiFormTemplate) {
            $scope.uiFormTemplate = uiFormTemplate;
        });
    }

    function updateFieldTemplate() {
        var value = $scope.expressionViewModel.value;
        $rootScope.$broadcast(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, {
            name: propertyName,
            value: value
        });
    }

    $scope.onExpressionChange = function () {
        $scope.expressionViewModel.isChanged = true;
    };

    $scope.onTest = function () {
        var regExp = $scope.expressionViewModel.value;
        var value = $scope.expressionViewModel.testData;
        // call rest to test the regular expression
        configurationMediator.validateRegExp(regExp, value).then(function (results) {
            var testResult = 'testSuccess';
            if (results && results.length > 0) {
                testResult = 'testFailure';
            }

            $scope.expressionViewModel.testResult = translations[testResult];
            $scope.expressionViewModel.testResultClass = testResult;
        });
    };

    $scope.onDone = function () {
        updateFieldTemplate();
        $scope.$dismiss();
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    $scope.$on(coreConstant.event.LOGOUT_COMPLETE, function (event) {
        $scope.$dismiss();
    });

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);

    init();
};

angular.module('umCore')
    .controller('regularExpressionController', RegularExpressionController);
